/**
 * Leer un archivo del disco SIN destruirlo por el camino.
 *
 * Existe por un defecto real: el levantamiento aceptaba `.xlsx` para el catálogo del contador
 * y lo leía con `await f.text()`. Un `.xlsx` es un ZIP binario, así que decodificarlo como
 * UTF-8 lo corrompe sin remedio — medido sobre un catálogo real de 239 cuentas: 5.650
 * caracteres de reemplazo (U+FFFD) y el archivo ya no se puede reconstruir. Aguas abajo el
 * parser NO lanzaba: "leía" 64 filas de ruido binario, y como la carga del catálogo es
 * best-effort, el alta seguía y el catálogo del contador desaparecía sin que nadie lo supiera.
 *
 * El navegador no tiene por qué entender Excel: manda los BYTES y el api los interpreta.
 */

/** Extensiones que sí son texto plano y se pueden leer como tal. */
const TEXTO_PLANO = ['.csv', '.tsv', '.txt', '.json'];

/** ¿Este archivo es texto plano, o hay que tratarlo como binario? */
export function esTextoPlano(nombre = '') {
  const n = String(nombre).toLowerCase();
  return TEXTO_PLANO.some((ext) => n.endsWith(ext));
}

/** El archivo como base64, sin el prefijo `data:...;base64,`. */
export function leerBase64(file) {
  return new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = () => resolve(String(fr.result).split(',')[1] || '');
    fr.onerror = reject;
    fr.readAsDataURL(file);
  });
}

/**
 * El contenido de un archivo listo para viajar en JSON, diciendo CÓMO viene codificado.
 *
 * `codificacion` es la pieza que faltaba: sin ella el receptor no puede saber si lo que le
 * llega es texto o bytes en base64, y adivinar es exactamente lo que rompía los `.xlsx`.
 *
 * @returns {Promise<{nombre:string, tamano:number, contenido:string, codificacion:'texto'|'base64'}>}
 */
export async function leerParaEnviar(file) {
  const comoTexto = esTextoPlano(file.name);
  return {
    nombre: file.name,
    tamano: file.size,
    contenido: comoTexto ? await file.text() : await leerBase64(file),
    codificacion: comoTexto ? 'texto' : 'base64',
  };
}
